import { useEffect, useMemo, useState } from 'react';
import { BREAKPOINT_ARRAY, BREAKPOINTS, Breakpoints, BreakpointSize } from './breakpoints';

export const buildMediaQueryFromSizes = (sizes: BreakpointSize[], breakpoints: Breakpoints = BREAKPOINTS): string => {
    const queries = sizes.map((size) => {
        const min = breakpoints[size];

        const currentIndex = BREAKPOINT_ARRAY.indexOf(size);
        const next = BREAKPOINT_ARRAY[currentIndex + 1];
        const max = next ? breakpoints[next] - 1 : null;

        if (max !== null) {
            return `(min-width: ${min}px) and (max-width: ${max}px)`;
        }

        return `(min-width: ${min}px)`;
    });

    return queries.join(', ');
};

export const useIsWithinBreakpoints = (sizes: BreakpointSize[], isActive: boolean = true) => {
    const sizesKey = JSON.stringify(sizes);
    // The eslint-disable-next-line comment is necessary because the linter can't understand that we're intentionally using sizesKey (which represents sizes) instead of sizes directly.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const query = useMemo(() => buildMediaQueryFromSizes(sizes, BREAKPOINTS), [sizesKey]);

    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined' ? window.matchMedia(query).matches : false
    );

    useEffect(() => {
        if (!isActive) return;

        const mediaQuery = window.matchMedia(query);

        const listener = (e: MediaQueryListEvent) => {
            setMatches(e.matches);
        };

        mediaQuery.addEventListener('change', listener);

        return () => {
            mediaQuery.removeEventListener('change', listener);
        };
    }, [query, isActive]);

    return matches;
};
